import { Button } from '@kidslabs/mario-nextjs-react-ui-core';
import React, { type FC, useCallback } from 'react';
import { observer } from '@legendapp/state/react';
import type { Observable } from '@legendapp/state';
import styles from './gift-selector-bottom-sheet-footer.module.css';

export interface GiftSelectorBottomSheetFooterProps {
    onBottomSheetClose: () => void;
    onConfirm?: () => void;
    /**
     * Observable for reactive confirming state.
     * Uses Legend-State observable so that the footer re-renders inside
     * a statically-injected bottom sheet when the value changes.
     */
    isConfirming$?: Observable<boolean>;
}

const GiftSelectorBottomSheetFooterInner: FC<GiftSelectorBottomSheetFooterProps> = observer(
    ({ onBottomSheetClose, onConfirm, isConfirming$ }) => {
        // Read from observable — observer() will re-render when value changes
        const isConfirming = isConfirming$?.get() ?? false;

        // Memoize skip handler
        const handleSkip = useCallback(() => {
            onBottomSheetClose();
        }, [onBottomSheetClose]);

        // Memoize confirm handler
        const handleConfirm = useCallback(() => {
            onConfirm?.();
        }, [onConfirm]);

        return (
            <div className={styles.footerActionsContainer}>
                <Button
                    className={styles.buttonSkip}
                    onClick={handleSkip}
                    variant="contained"
                    colorRole="secondary"
                    size="large"
                    disabled={isConfirming}
                >
                    Bỏ qua
                </Button>
                <Button
                    className={styles.buttonAccept}
                    onClick={handleConfirm}
                    variant="contained"
                    colorRole="primary"
                    size="large"
                    loading={isConfirming}
                    disabled={isConfirming}
                >
                    Xác nhận
                </Button>
            </div>
        );
    }
);

GiftSelectorBottomSheetFooterInner.displayName = 'GiftSelectorBottomSheetFooter';

// Export memoized version to prevent unnecessary re-renders
export const GiftSelectorBottomSheetFooter = React.memo(GiftSelectorBottomSheetFooterInner);
